import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { taskAssign, userManagement } from "../../config/images";
import { useNavigate, useLocation } from "react-router-dom";
import translations from "../../config/language";
import { Button } from "../../components/Button/button";
import { addRole, gerModuleList, getRoleList, editRole } from "../../config/services";
import { notifyError, notifySuccess } from "../../config/ToastMessage";
import { useSelector } from "react-redux";

const RoleManagementPermission = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const language = process.env.REACT_APP_LANGUAGE;
  const [loading, setLoading] = useState(false);
  const [moduleData, setModuleData] = useState([]);
  const [fetchRoleData, setFetchRoleData] = useState([]);
  const [role_id, setRoleId] = useState(location.state?.roleId || '');
  const [isAddRole, setAddRole] = useState(false)
  const [permissions, setPermissions] = useState({
    admin: '',
    farmers: '',
    taskAssignment: '',
    collectors: '',
    reportSubmission: '',
    categoryMaster: '',
    userManagement: '',
  });
  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Role Management" && module.is_editor === true
  ) ? true : false;
  const handlePermissionChange = (key, value) => {
    setPermissions(prev => ({
      ...prev,
      [key]: value
    }));
  };
  const PermissionSelect = ({ moduleName, moduleKey }) => (
    <Box className="d-flex justify-content-between align-items-center">
      <Typography variant="p">{moduleName}</Typography>
      <FormControl className="mb-3" style={{ width: "200px" }}>
        <InputLabel>Select Access</InputLabel>
        <Select
          label="Select Access"
          name={moduleKey}
          value={permissions[moduleKey] || ''}
          onChange={(e) => handlePermissionChange(moduleKey, e.target.value)}
        >
          <MenuItem value="view">Can View</MenuItem>
          <MenuItem value="edit">Can View & Edit</MenuItem>
          <MenuItem value="noAccess">No Access</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
  const handleUpdate = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    const matchingRole = fetchRoleData.find(role => role.id === Number(role_id));
    const permissionsArray = moduleData.map(module => {
      const accessValue = permissions[module.id];
      const existingModule = matchingRole?.modules.find(m => m.module_id === module.id);
      return {
        module_id: existingModule?.id,
        is_viewer: accessValue === 'view' || accessValue === 'edit',
        is_editor: accessValue === 'edit',
        no_access: accessValue === 'noAccess' || !accessValue
      };
    });
    const params = {
      role_id: matchingRole?.id || role_id,
      role_name: matchingRole?.role_name || location.state?.editRoleName || '',
      permissions: permissionsArray
    };
    try {
      setLoading(true);
      const response = await editRole(params, role_id);
      if (response.data.success === true) {
        notifySuccess(response.data.message);
        navigate("/role-management");
      }
    } catch (error) {
      console.error('Error updating role:', error);
      notifyError(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchRoleList = async () => {
    try {
      const response = await getRoleList(null, null, role_id);
      if (response.data.results.success == true) {
        setFetchRoleData(response.data.results.payload);
      }
    } catch (error) {
      console.error('Error adding role:', error);
      notifyError(error.response.data.message);
    }
  }
  useEffect(() => {
    if (location.state?.roleId) {
      fetchRoleList();
    }
  }, [location.state?.roleId]);
  useEffect(() => {
    if (fetchRoleData && fetchRoleData.length > 0) {
      const modulePermissions = {};
      const matchingRole = fetchRoleData.find(role => role.id === Number(role_id));

      if (matchingRole?.modules) {
        matchingRole.modules.forEach(module => {
          let accessValue = 'noAccess';
          if (module.is_editor) {
            accessValue = 'edit';
          } else if (module.is_viewer) {
            accessValue = 'view';
          }
          modulePermissions[module.module_id] = accessValue;
        });
        setPermissions(modulePermissions);
      }
    }
  }, [fetchRoleData, role_id]);
  const handleAddRole = async () => {
    const permissionsArray = moduleData.map(module => {
      const accessValue = permissions[module.id];
      return {
        module_id: module.id,
        is_viewer: accessValue === 'view' || accessValue === 'edit',
        is_editor: accessValue === 'edit',
        no_access: accessValue === 'noAccess' || !accessValue
      };
    });

    const params = {
      role_name: location.state?.roleName || '',
      permissions: permissionsArray
    };

    try {
      const response = await addRole(params);
      if (response.data.success == true) {
        notifySuccess(response.data.message);
        navigate("/role-management");
      }
    } catch (error) {
      console.error('Error adding role:', error);
      notifyError(error.response.data.message);
    }
  };
  useEffect(() => {
    if (location.state?.isAdd) {
      setAddRole(true);
    } else {
      setAddRole(false);
    }
  }, [])
  const fetchModuleDataList = async () => {
    try {
      const response = await gerModuleList();
      if (response.status === 200) {
        setModuleData(response.data.payload);
      }
    } catch (error) {
      console.error('Error fetching module data:', error);
    }
  };
  useEffect(() => {
    fetchModuleDataList();
  }, []);

  return (
    <Box className="task-detail-box">
      <Box className="d-flex justify-content-between align-items-center">
        <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
          <img
            src={taskAssign.backArrow}
            alt=""
            style={{ height: "44px", width: "44px", cursor: "pointer" }}
            onClick={() => navigate("/role-management")}
          />
          <img src={userManagement.userManagementIcon} alt="" />
          <Typography variant="h6" gutterBottom>
            {translations[language].roleManagement}
          </Typography>
        </Box>
      </Box>

      <Box className="p-3 pb-0">
        <Box className="d-flex justify-content-between">
          <Typography variant="p">Roles(Module)</Typography>
          <Typography variant="p">Access</Typography>
        </Box>
      </Box>
      <hr className="mt-2" />

      <Box className="p-4 pt-0">
        {moduleData.map(module => (
          <PermissionSelect
            key={module.id}
            moduleName={module.module_name}
            moduleKey={module.id}
          />
        ))}
      </Box>

      <Box className="d-flex justify-content-end p-4">
        <Box className="d-flex gap-3" style={{ whiteSpace: 'nowrap' }}>
          <Button
            title={translations[language].cancel}
            classname={"border-btn"}
            onClick={() => navigate("/role-management")}
          />
          <Button
            title={isAddRole ? translations[language].addRole : translations[language].update}
            classname={"custom-button"}
            onClick={isAddRole ? handleAddRole : handleUpdate}
            loading={loading}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default RoleManagementPermission;